module.exports = __webpack_public_path__ + "img/tapestry-of-golden-flames.63fca4c0.webp";